/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calibration_Temperature_Error_TitleInputs */



/**
* | output |
* | --- |
* | "Inappropriate time to recalibrate the room temperature" |
*
* @param {Calibration_Temperature_Error_TitleInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const calibration_temperature_error_title = /** @type {((inputs?: Calibration_Temperature_Error_TitleInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calibration_Temperature_Error_TitleInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Inappropriate time to recalibrate the room temperature")
	return /** @type {LocalizedString} */ ("Moment inadapté pour calibrer la température de la pièce")
});